import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const EnquiryService = {
  getAllEnquiries: async () => {
    try {
      const response = await axios.get(ENDPOINT.enquiries);
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },

  getAllEnquiriesById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.enquiries}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },

  getCustomerDataByQuID:async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.customer_qu}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },
  getFormatedData:async (data) => {
    try {
      const response = await axios.post(`${ENDPOINT.formatedDataSource}`, data);
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },
  formatQuote:async (id) => {
    try {
      const response = await axios.post(`${ENDPOINT.formatQuote}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },

  getAllActiveEnquiriesById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.enquiries}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },
  getAllProductSuggestions: async (data) => {
    try {
      const response = await axios.get(`${ENDPOINT.suggestions}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },

   getEnquiryDetailsById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.enquiries}/eq/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },

  createEnquiries: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.enquiries, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },

  updateEnquiries: async (data) => {
    try {
      const response = await axios.put(ENDPOINT.enquiries, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },

  deleteEnquiries: async (data) => {
    try {
      const response = await axios.delete(ENDPOINT.enquiries, {
        headers: {
          "Content-Type": "application/json",
        },
        data, 
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting enquiries:", error.message);
      throw error;
    }
  },

  createCustomer: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.customer, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },

  updateCustomer: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.customer}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching enquiries:", error.message);
      throw error;
    }
  },
}